import {
    EXPERIMENTAL_MEMBER_AGENT_REFS,
    MEMBER_AGENTS,
    SPROUT_AGENT,
} from '@fruitful/llm-service-shared';
import { Dropdown } from 'primereact/dropdown';

export const SPROUT_EXPERIMENT_AGENTS = [
    ...MEMBER_AGENTS,
    ...EXPERIMENTAL_MEMBER_AGENT_REFS,
];

export const ExperimentAgentDropdown = ({
    agentKey,
    onAgentKeyChange,
}: {
    agentKey: string;
    onAgentKeyChange: (agentKey: string) => void;
}) => {
    if (SPROUT_EXPERIMENT_AGENTS.length <= 1) {
        return null;
    }

    const selected = SPROUT_EXPERIMENT_AGENTS.some(
        (agent) => agent.agentKey === agentKey,
    )
        ? agentKey
        : SPROUT_AGENT.agentKey;

    return (
        <Dropdown
            value={selected}
            options={SPROUT_EXPERIMENT_AGENTS.map((agent) => ({
                label: agent.agentKey,
                value: agent.agentKey,
            }))}
            onChange={(event) => {
                if (typeof event.value !== 'string' || event.value === '') {
                    return;
                }
                onAgentKeyChange(event.value);
            }}
            style={{ width: 240 }}
        />
    );
};
